import React from 'react';
import { CTAButton } from './CTAButton';
import { PRODUCT_IMAGE, stats } from '../data/content';
export function Hero() {
  return <header className="relative overflow-hidden border-b border-line bg-night" data-id="element-141" data-mp="eiboxjpyos8e">
      <div className="pointer-events-none absolute inset-x-0 -top-40 h-80 bg-lime/10 blur-[120px]" aria-hidden="true" data-id="element-142" data-mp="9luz8l3465t7" />
      <div className="relative mx-auto w-full max-w-5xl px-4 pb-10 pt-8 sm:px-6 sm:pt-12" data-id="element-143" data-mp="4jm71qy2f7s5">
        <p className="text-center font-display text-sm font-bold uppercase tracking-[0.3em] text-lime" data-id="element-144" data-mp="127efjh2kpvf1">
          Dre Karito
        </p>

        <h1 className="mx-auto mt-6 max-w-3xl text-center font-display text-[32px] font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-[56px]" data-id="element-145" data-mp="sb1efy4p8fa9">
          Prenez des décisions sûres face à tout patient rénal en{' '}
          <span className="text-lime" data-id="element-146" data-mp="3d33gb2q0p1mv">moins de 5 minutes</span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-center text-[15px] leading-relaxed text-slate-300 sm:text-lg" data-id="element-147" data-mp="3825wymt9u1js">
          De l’interprétation d’une créatinine élevée à la décision de traiter, surveiller ou
          orienter. Sans consulter plusieurs guides ni douter en pleine consultation.
        </p>

        <p className="mx-auto mt-4 max-w-2xl text-center text-[14px] leading-relaxed text-slate-400" data-id="element-148" data-mp="399bavmrkdbvg">
          Plus de <strong className="text-white" data-id="element-149" data-mp="3e84m18jdoqsg">1 000 médecins</strong> hispanophones utilisent déjà
          Route Maladie Rénale™ pour transformer l’incertitude clinique en décisions claires et
          fondées sur les preuves.
        </p>

        <figure className="mt-8" data-id="element-150" data-mp="35akmq552t4kh">
          <img src={PRODUCT_IMAGE} alt="Les 6 volumes et 5 bonus de Route Maladie Rénale™ en version numérique" className="mx-auto w-full max-w-2xl" width={1080} height={1080} data-id="element-151" data-mp="2qkda461r2frp" />
          <figcaption className="mt-2 text-center text-[12px] font-medium uppercase tracking-wide text-slate-500" data-id="element-152" data-mp="2hjymh01bcol1">
            Les 6 volumes et 5 bonus en version numérique
          </figcaption>
        </figure>

        <div id="hero-cta" className="mt-8" data-id="element-153" data-mp="s3uqvwnx98am">
          <CTAButton label="Je veux ma Route Rénale prête" caption="Téléchargement immédiat • Paiement unique • Accès à vie • Garantie de 7 jours" data-id="element-154" data-mp="nb1o3ec0ka16" />
        </div>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[12px] font-semibold uppercase tracking-wide text-slate-500" data-id="element-155" data-mp="ddwyf4iylwfm">
          <li data-id="element-156" data-mp="1ayjiziqkro8d">Basé sur KDIGO</li>
          <li aria-hidden="true" data-id="element-157" data-mp="161b0fh1ili6l">•</li>
          <li data-id="element-158" data-mp="162c95ev25sl5">PDF haute qualité</li>
          <li aria-hidden="true" data-id="element-159" data-mp="112pur23hu6ar">•</li>
          <li data-id="element-160" data-mp="111om149y9vw7">Prêt à utiliser dès aujourd’hui</li>
        </ul>
      </div>

      <div className="border-t border-line bg-ink" data-id="element-161" data-mp="x1ec5gj1elc2">
        <dl className="mx-auto grid w-full max-w-5xl grid-cols-2 gap-px overflow-hidden bg-line px-0 sm:grid-cols-5" data-id="element-162" data-mp="x0uwy7krub1q">
          {stats.map(stat => <div key={stat.label} className="bg-ink px-3 py-5 text-center last:col-span-2 sm:last:col-span-1" data-id="element-163" data-mp="3hqtynzb83nvw">
              <dt className="sr-only" data-id="element-164" data-mp="1xacfx49qzltr">{stat.label}</dt>
              <dd data-id="element-165" data-mp="1x7hvhcqqi10c">
                <span className="block font-display text-2xl font-extrabold text-lime sm:text-3xl" data-id="element-166" data-mp="21amtp33s7gj6">
                  {stat.value}
                </span>
                <span className="mt-1 block text-[10px] font-bold uppercase tracking-[0.14em] text-slate-500" data-id="element-167" data-mp="268odxrcy1lw8">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </header>;
}